import { extractErrorMessage, useCreateZipJob } from '@sib/api';
import { useTranslation } from '@sib/i18n';
import { useNotification } from '@sib/notifications';

interface UseExportDocumentsZipOptions {
  organizationId: string;
  onSuccess?: () => void;
  errorMessage?: string;
}

export const useExportDocumentsZip = ({
  organizationId,
  onSuccess,
  errorMessage,
}: UseExportDocumentsZipOptions) => {
  const { t } = useTranslation();
  const { open } = useNotification();

  const createZipJob = useCreateZipJob({
    onSuccess: data => {
      window.open(data.sasUrl, '_blank');
      onSuccess?.();
    },
    onError: error => {
      open({
        type: 'error',
        message:
          extractErrorMessage(error) ||
          errorMessage ||
          t('errors.server.INTERNAL_SERVER_ERROR.message'),
      });
    },
  });

  return {
    exportDocuments: (documentIds: string[]) => {
      if (documentIds.length === 0) return;

      createZipJob.mutate({ organizationId, documentIds });
    },
    isExporting: createZipJob.isPending,
  };
};
